"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GodMode = void 0;
var _shoppingContext = require("@ori/shopping-context");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const Content = /*#__PURE__*/ (0, _react.lazy)(async ()=>Promise.resolve().then(()=>_interopRequireWildcard(require('./containers/GodModeApp'))));
const GodMode = ()=>{
    const { shoppingContext } = (0, _shoppingContext.useShoppingContext)();
    return (shoppingContext === null || shoppingContext === void 0 ? void 0 : shoppingContext.godModeOutput) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Suspense, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Content, {})
    }) : null;
};
exports.GodMode = GodMode;
